import React from "react";
import Lazyload from "react-lazyload";
import OnnetworkPlayer from "../../OnnetworkPlayer";

export default class OnnetworkVideo extends React.Component {
  render() {

    return (
      <Lazyload height={200} offset={500} once={true}>
        <OnnetworkPlayer mid={this.props.mid} />
      </Lazyload>
    );
  }
}
